/**
 * How a payee name was made (TMMAPI-0193 U3, `naming_source`): the person's rule, a known merchant,
 * the bank's own text, or AI. Served on the owner's register line, on an `AI_PAYEE_PROPOSAL` review
 * item, and as `naming-status.bySource`'s keys.
 */
export type NamingSource = 'RULE' | 'KNOWN_MERCHANT' | 'BANK_TEXT' | 'AI';

/** The split's order, free first (TMMAPP-0163 item 5). */
export const NAMING_SOURCES: readonly NamingSource[] = [
  'RULE',
  'KNOWN_MERCHANT',
  'BANK_TEXT',
  'AI',
];

/** A served source; an unknown or absent one is `null` (no label, never a crash). */
export function normalizeNamingSource(value: string | null | undefined): NamingSource | null {
  return (NAMING_SOURCES as readonly (string | null | undefined)[]).includes(value)
    ? (value as NamingSource)
    : null;
}
